// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"bef2cc98","239":"3f2d2005"}[chunkId] + ".css";
};